/*
  KP: notification bell panel (sections/kp-notifications.liquid).
  Opens and closes the panel, marks cards as seen, and handles the trending products arrow.
  The bell itself is placed by the small script inside the section.
*/
(function () {
  'use strict';

  var root = document.getElementById('KpNotify');
  if (!root) return;

  var KEY = 'kpNotifySeen';
  var layer = null;
  var panel = null;
  var lastBell = null;

  // The cards are not in the page at first (see the SPEED note in sections/kp-notifications.liquid):
  // they are fetched once the page has loaded, or as soon as the bell is tapped.
  var lazy = root.hasAttribute('data-kp-notify-lazy');
  var loading = null;

  function load() {
    if (!lazy) return Promise.resolve(true);
    if (loading) return loading;

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = base + 'search?q=kp-notify-panel&section_id=' + encodeURIComponent(root.getAttribute('data-section-id') || '');

    loading = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('kp-notify');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('template[data-kp-notify-panel]');
        var current = root.querySelector('template[data-kp-notify-panel]');
        if (!fresh || !current || !fresh.content.querySelector('[data-kp-notify-item]')) throw new Error('kp-notify');
        current.parentNode.replaceChild(document.importNode(fresh, true), current);
        lazy = false;
        return true;
      })
      .catch(function () {
        loading = null;
        return false;
      });

    return loading;
  }

  // Fetched quietly once the page has finished loading, so it is ready before anyone taps.
  function loadLater() {
    var go = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 3000 });
      else window.setTimeout(load, 1500);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
  }

  loadLater();

  function ids() {
    return (root.getAttribute('data-ids') || '').split(',').filter(Boolean);
  }

  function seen() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }

  function markAllSeen() {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids()));
    } catch (e) {
      /* Private browsing: the count simply comes back next visit. */
    }
    if (window.kpNotifyCount) window.kpNotifyCount();
  }

  function setBells(open) {
    var bells = document.querySelectorAll('[data-kp-notify-open]');
    for (var i = 0; i < bells.length; i++) {
      bells[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function focusable() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      return el.offsetParent !== null;
    });
  }

  function onKey(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    // Keep keyboard focus inside the panel while it is open.
    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  // GIFs on the cards are shown still (16 Oct 2026, Sana), as in the phone menu: Shopify's image
  // server sends the first frame as a PNG when the address asks for format=png. Done before the
  // cards go into the page, so the moving GIF is never downloaded.
  function still(content) {
    var images = content.querySelectorAll('img[src]');
    for (var i = 0; i < images.length; i++) {
      var src = images[i].getAttribute('src');
      if (!/\.gif(\?|$)/i.test(src) || src.indexOf('format=png') > -1) continue;
      images[i].setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'format=png');
    }
  }

  function build() {
    var template = root.querySelector('template[data-kp-notify-panel]');
    layer = document.createElement('div');
    layer.className = 'kp-notify__layer';
    layer.hidden = true;
    var content = template.content.cloneNode(true);
    still(content);
    layer.appendChild(content);
    document.body.appendChild(layer);
    panel = layer.querySelector('.kp-notify__panel');

    layer.addEventListener('click', function (event) {
      if (event.target.closest('[data-kp-notify-close]')) {
        close();
        return;
      }
      var toggle = event.target.closest('[data-kp-notify-toggle]');
      if (toggle) {
        var box = toggle.closest('[data-kp-notify-trending]');
        var expanded = box.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    });
    layer.addEventListener('keydown', onKey);
  }

  // Desktop: line the box up under the bell that was clicked. (Phones ignore these values.)
  function position() {
    if (!layer || !lastBell) return;
    var rect = lastBell.getBoundingClientRect();
    var width = document.documentElement.clientWidth;
    layer.style.setProperty('--kp-notify-top', Math.max(8, Math.round(rect.bottom + 8)) + 'px');
    layer.style.setProperty('--kp-notify-right', Math.max(8, Math.round(width - rect.right)) + 'px');
  }

  function isOpen() {
    return !!layer && !layer.hidden;
  }

  function open(bell) {
    if (lazy) {
      load().then(function (ok) {
        if (ok && !isOpen()) open(bell);
      });
      return;
    }
    if (!layer) build();
    lastBell = bell;

    // Blue dot on the cards that are new to this visitor.
    var before = seen();
    var items = layer.querySelectorAll('[data-kp-notify-item]');
    for (var i = 0; i < items.length; i++) {
      var isNew = before.indexOf(items[i].getAttribute('data-kp-notify-item')) === -1;
      items[i].classList.toggle('is-unread', isNew);
    }

    position();
    layer.hidden = false;
    document.documentElement.classList.add('kp-notify-open');
    setBells(true);
    markAllSeen();
    try {
      panel.focus({ preventScroll: true });
    } catch (e) {
      panel.focus();
    }
    window.addEventListener('resize', position);
  }

  function close() {
    if (!isOpen()) return;
    layer.hidden = true;
    document.documentElement.classList.remove('kp-notify-open');
    setBells(false);
    window.removeEventListener('resize', position);
    if (lastBell && document.contains(lastBell) && lastBell.offsetParent !== null) {
      try {
        lastBell.focus({ preventScroll: true });
      } catch (e) {
        lastBell.focus();
      }
    }
  }

  document.addEventListener('click', function (event) {
    var bell = event.target.closest('[data-kp-notify-open]');
    if (!bell) return;
    event.preventDefault();
    if (isOpen()) {
      close();
    } else {
      open(bell);
    }
  });

  // Theme editor: the header is redrawn when its settings change, so put the bell back.
  document.addEventListener('shopify:section:load', function () {
    if (window.kpNotifyPlace) window.kpNotifyPlace();
  });
})();
